import * as React from "react";
import { Text, TextVariant } from "../../../ui";

export const EmptySection: React.FC = ({ children }) => (
  <Text variant={TextVariant.BODY2} className="text-gray-400 py-3">
    {children}
  </Text>
);
